import { useCallback } from 'react';
import * as React from 'react';
import { Box, Flex, FlexProps, Link } from 'roo-ui/components';
import styled from '@emotion/styled';
import { useActions } from 'lib/hooks/useActions';

const FlexLink = (props: FlexProps) => <Flex {...props} />;

const StyledLink = styled(Link)`
  color: inherit;
  text-decoration: none;
`;

StyledLink.displayName = 'StyledLink';

interface InfoWrapperProps extends React.PropsWithChildren<any> {
  bookingId: string;
  [key: string]: any;
}

export const InfoWrapper = ({ bookingId, children, ...rest }: InfoWrapperProps) => {
  const { navigation } = useActions();
  const goToBookingDetails = useCallback(() => navigation.goToBookingDetails({ bookingId: bookingId }), [navigation, bookingId]);

  return (
    <Box px={[4, 5]} width="100%">
      <FlexLink as={StyledLink} onClick={goToBookingDetails} flexDirection="column" {...rest}>
        {children}
      </FlexLink>
    </Box>
  );
};
